(() => {
  const sections = document.querySelectorAll("[data-onura-reviews]");

  if (!sections.length) return;

  sections.forEach((section) => {
    const track = section.querySelector("[data-onura-reviews-track]");
    const prevButton = section.querySelector("[data-onura-reviews-prev]");
    const nextButton = section.querySelector("[data-onura-reviews-next]");

    if (!track || !prevButton || !nextButton) return;

    const getScrollAmount = () => {
      const firstCard = track.querySelector(".onura-review-card");

      if (!firstCard) return track.clientWidth * 0.85;

      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || 0);

      return firstCard.getBoundingClientRect().width + gap;
    };

    const updateButtons = () => {
      const maxScrollLeft = track.scrollWidth - track.clientWidth - 2;

      prevButton.disabled = track.scrollLeft <= 2;
      nextButton.disabled = track.scrollLeft >= maxScrollLeft;
    };

    const scrollByDirection = (direction) => {
      track.scrollBy({
        left: getScrollAmount() * direction,
        behavior: "smooth"
      });
    };

    prevButton.addEventListener("click", () => {
      scrollByDirection(-1);
    });

    nextButton.addEventListener("click", () => {
      scrollByDirection(1);
    });

    track.addEventListener("scroll", updateButtons, { passive: true });
    window.addEventListener("resize", updateButtons);

    updateButtons();
  });
})();